// extracted by mini-css-extract-plugin
module.exports = {"main":"Link_main__272r8","expand":"Link_expand__36Vad"};